import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Card,
  Divider,
  Avatar,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import { Edit, Delete, Search } from "@mui/icons-material";
import ApiEndpoints from "../../network/ApiEndPoints";
import ApiPaginateSearch from "../../component/ApiPaginateSearch";
import { dateToTime, dateToTime1, ddmmyy } from "../../utils/DateUtils";
import AuthContext from "../../store/AuthContext";
import { CustomStyles } from "../../component/CustomStyle";
import CachedIcon from "@mui/icons-material/Cached";
import FilterCard from "../../modals/FilterCard";
import VisibilityIcon from "@mui/icons-material/Visibility";

import DataFilter from "./Common/DataFilter";
import ViewModal from "../../modals/ViewModal";
import FilterModal from "../../modals/FilterModal";
import { useMediaQuery, useTheme } from "@mui/material";
import CreateAssetModal from "./CreateAssetModal";
import EditAssetModal from "./EditAssetModal";
let refresh;
const Assets = ({}) => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  const [search, setSearch] = useState("");
  const [hiddenButton, setHiddenButton] = useState("");
  const [request, setRequest] = useState(false);
  const [users, setUsers] = useState({}); // Store user ID -> Name mapping
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [editAssetData, setEditAssetData] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);

  const columns = [
 {
  name: "Date",
  selector: (row) => (
    <>
      {/* Created At */}
      <Tooltip title={`Created Time: ${dateToTime(row.created_at)}`}>
        <div>
          <span>{ddmmyy(row.created_at)}</span>
          <span style={{ marginLeft: "6px" }}>
            {dateToTime1(row.created_at)}
          </span>
        </div>
      </Tooltip>

      {/* Updated At */}
      <Tooltip title={`Updated Time: ${dateToTime(row.updated_at)}`}>
        <div style={{ marginTop: "4px" }}>
          <span>{ddmmyy(row.updated_at)}</span>
          <span style={{ marginLeft: "6px" }}>
            {dateToTime1(row.updated_at)}
          </span>
        </div>
      </Tooltip>
    </>
  ),
},


    {
      name: "Purchase Date",
      selector: (row) => (
        <>
          <Tooltip title="Start Date">
            <div>
              <span>{ddmmyy(row.purchase_date)}</span>
              <span style={{ marginLeft: "6px" }}>
                {dateToTime1(row.created_at)}
              </span>
            </div>
          </Tooltip>
          {/* <Tooltip title="End Date">
            <div style={{ marginBottom: "0.3em" }}>
              {ddmmyy(row.end_date)}
              <span style={{ marginLeft: "6px" }}>
                {dateToTime1(row.updated_at)}
              </span>
            </div>
          </Tooltip> */}
        </>
      ),
    },

    {
      name: "Purchased From",
      selector: (row) => {
        return (
          <div
            style={{ marginBottom: "12px", color: "#333", fontSize: "14px" }}
          >
            {row.purchase_from}
          </div>
        );
      },
      wrap: true,
      width: "150px",
    },
    {
      name: "Asset Name",
      selector: (row) => {
        return (
          <div
            style={{ marginBottom: "12px", color: "#333", fontSize: "14px" }}
          >
            {row.name}
          </div>
        );
      },
      wrap: true,
      width: "150px",
    },

    {
      name: "Description",
      selector: (row) => {
        const hasScrollbar = row.description.length > 150;

        return (
          <div
            style={{
              maxHeight: "80px",
              overflowY: "auto",
              padding: "10px",
              position: "relative",
              borderRadius: "8px",
              background: "#f9f9f9",
              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
              scrollbarWidth: "thin",
              scrollbarColor: "rgb(151, 148, 148) #f9f9f9",
            }}
          >
            <div
              style={{ marginBottom: "12px", color: "#333", fontSize: "14px" }}
            >
              {row.description}
            </div>
          </div>
        );
      },
      wrap: true,
      width: "240px",
    },
    {
      name: "Asset Cost",
      selector: (row) => {
        return (
          <div
            style={{ marginBottom: "12px", color: "#333", fontSize: "14px" }}
          >
            {row.cost}
          </div>
        );
      },
      wrap: true,
      width: "150px",
    },
    {
      name: "Category",
      selector: (row) => {
        return (
          <div
            style={{ marginBottom: "12px", color: "#333", fontSize: "14px" }}
          >
            {row.category}
          </div>
        );
      },
      wrap: true,
      width: "150px",
    },

    {
      name: "Asset Image",
      selector: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* {row?.invoices === null ? (
            <VisibilityIcon sx={{ color: "grey" }} />
          ) : (
            <ViewModal row={row} title="Task Image" />
          )} */}
          <img
            src={row.image_url}
            alt="asset image"
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
          {/* </img> */}
          {/* {row?.invoices} */}
        </div>
      ),
    },
    user.role === "Admin" && {
      name: "Assigned To",
      selector: (row) => (
        <>
          <div>
            {row.assigned_name ? (
              row.assigned_name
            ) : (
              <span style={{ color: "red" }}>Not Assigned</span>
            )}
          </div>
        </>
      ),
    },
    user.role === "Admin" && {
      name: "Actions",
      selector: (row) => (
        <Box display="flex" gap={1}>
          <Tooltip title="Edit">
            <Edit
              sx={{ cursor: "pointer", color: "#1976d2" }}
              onClick={() => {
                setEditAssetData(row);
                setOpenEditModal(true);
              }}
            />
          </Tooltip>
        </Box>
      ),
      width: "100px",
    },
  ];
  return (
    <>
      <Grid sx={{ mt: 2.5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            mb: 2,
          }}
        >
          {user.role === "Admin" && (
            <CreateAssetModal onSuccess={() => refresh && refresh()} />
          )}
        </Box>

        <ApiPaginateSearch
          apiEnd={ApiEndpoints.GET_ASSET}
          columns={columns}
          apiData={apiData}
          setApiData={setApiData}
          tableStyle={CustomStyles}
          queryParam={query ? query : ""}
          returnRefetch={(ref) => {
            refresh = ref;
          }}
        />
        <EditAssetModal
          open={openEditModal}
          onClose={() => setOpenEditModal(false)}
          data={editAssetData}
          onSuccess={() => {
            setOpenEditModal(false);
            refresh && refresh();
          }}
        />
      </Grid>
    </>
  );
};

export default Assets;
